import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Polyline, Popup, CircleMarker, useMap } from "react-leaflet";
import L from "leaflet";
import { PIN_COLORS, catInfo } from "@/lib/constants";

const pin = (label, color, active) =>
  L.divIcon({ className: "", html: `<div class="ob-pin ${active ? "active" : ""}" style="background:${color}">${label}</div>`, iconSize: [34, 34], iconAnchor: [17, 17] });
const startIcon = L.divIcon({ className: "", html: `<div class="ob-start"></div>`, iconSize: [22, 22], iconAnchor: [11, 11] });

const Fit = ({ points }) => {
  const map = useMap();
  const key = points.map((p) => p.join(",")).join("|");
  useEffect(() => {
    if (!points.length) return;
    if (points.length === 1) map.setView(points[0], 15);
    else map.fitBounds(points, { padding: [70, 70], maxZoom: 16 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return null;
};

export const PlanMap = ({ start, stops = [], dots = [], activeSid, onSelect }) => {
  const route = [...(start ? [[start.lat, start.lon]] : []), ...stops.map((s) => [s.lat, s.lon])];
  const points = [...route, ...dots.map((d) => [d.lat, d.lon])];
  return (
    <MapContainer center={[39.5, -98.35]} zoom={4} className="w-full h-full" zoomControl={false} data-testid="plan-map">
      <TileLayer
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        maxZoom={19}
      />
      <Fit points={points} />
      {route.length > 1 && <Polyline positions={route} pathOptions={{ color: "#B8892B", weight: 4, opacity: 0.85, dashArray: "8 8" }} />}
      {start && (
        <Marker position={[start.lat, start.lon]} icon={startIcon}>
          <Popup>Start: {start.label}<br /><small>Visible only to you unless you choose to show it.</small></Popup>
        </Marker>
      )}
      {stops.map((s, i) => (
        <Marker key={s.sid} position={[s.lat, s.lon]} icon={pin(i + 1, PIN_COLORS[i % PIN_COLORS.length], s.sid === activeSid)}
          eventHandlers={{ click: () => onSelect?.(s.sid) }}>
          <Popup><strong>{i + 1}. {s.name}</strong><br />{catInfo(s.cat).label}{s.arrive ? ` · ${s.arrive}` : ""}</Popup>
        </Marker>
      ))}
      {dots.map((d) => (
        <CircleMarker key={d.pid} center={[d.lat, d.lon]} radius={7} pathOptions={{ color: "#fff", weight: 2, fillColor: "#163A2B", fillOpacity: 0.9 }}>
          <Popup>{d.name}<br />{catInfo(d.cat).label}</Popup>
        </CircleMarker>
      ))}
    </MapContainer>
  );
};
